import styled from 'styled-components';

import {dimensions} from '@stryd/react-ui';

import {colors as customColors} from 'src/styles/colors';

import {GridItem, LinkGridLayout} from '../LinkGridLayout';

import {defaultPagePaddingMixin} from './DefaultPagePadding';

const SectionContainer = styled.section`
  background-color: ${customColors.backgroundLight};
  width: 100%;
  min-height: 100vh;

  @media screen and (max-width: ${dimensions.breakpoints.tabletLandscape}) {
    align-items: flex-start;
  }

  ${defaultPagePaddingMixin}
`;

interface ProductLinkGridSectionProps {
  sectionContainerStyle?: React.CSSProperties;
  title: React.ReactNode;
  items: GridItem[];
}

export const ProductLinkGridSection: React.FC<ProductLinkGridSectionProps> = ({
  sectionContainerStyle,
  title,
  items,
}) => {
  return (
    <SectionContainer style={sectionContainerStyle}>
      <LinkGridLayout gridTitle={title} items={items} />
    </SectionContainer>
  );
};
